<script setup lang="ts">
	const isOpenModalForOrder = ref(false);
	const { menus } = useMenus();
</script>

<template>
	<header id="header" class="app-header">
		<NuxtLink to="/" class="app-header__link-logo">
			<NuxtImg src="/images/svg/logo.svg" alt="logo" preload class="app-header__logo" />
		</NuxtLink>
		<menu aria-label="Основная навигация" class="app-header__menu-list">
			<li v-for="menuItem in menus" :key="menuItem.title" class="menu-list__item">
				<NuxtLink :to="menuItem.path" class="menu-list__item-link">
					{{ menuItem.title }}
				</NuxtLink>
			</li>
		</menu>
		<button class="app-header__button button" @click="isOpenModalForOrder = true">Написать нам</button>
		<AppBurger class="app-header__burger" @show-order-request="isOpenModalForOrder = true" />

		<AppModal
			v-if="isOpenModalForOrder"
			v-model:is-open="isOpenModalForOrder"
			modal-title="Оставить заявку"
		>
			<FormOrderRequest
				@submit-form="isOpenModalForOrder = false"
				@close-form="isOpenModalForOrder = false"
			/>
		</AppModal>
	</header>
</template>

<style lang="scss" scoped>
	.app-header {
		position: relative;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		padding: 15px 0px;
		height: var(--height-header);
	}
	.app-header__link-logo {
		display: flex;
		align-self: center;
		width: 218px;
		height: 28px;
	}
	.app-header__logo {
		width: 218px;
	}
	.app-header__menu-list {
		display: none;
	}
	.app-header__button {
		display: none;
	}

	@media (min-width: 1240px) {
		.app-header {
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 20px 0px;
		}
		.app-header__link-logo {
			position: absolute;
			display: flex;
			align-self: center;
			left: 0;
			width: 241px;
			height: 31px;
			&:focus-visible {
				outline-color: var(--color-primary);
				outline-width: 1px;
				outline-style: solid;
				outline-offset: 5px;
				border-radius: 5px;
			}
		}
		.app-header__logo {
			width: 241px;
		}
		.app-header__menu-list {
			display: flex;
			gap: 45px;
			.menu-list__item {
				display: block;
			}
			.menu-list__item-link {
				position: relative;
				display: flex;
				align-items: center;
				height: 42px;
				text-decoration: none;
				&:after {
					position: absolute;
					content: '';
					display: block;
					width: 100%;
					height: 2px;
					left: 0;
					bottom: 10%;
					opacity: 0;
					transition: 0.4s;
					margin-top: -1px;
					background-color: var(--color-secondary);
					background-color: var(--color-black);
					opacity: 1;
					transform: scaleX(0);
				}
				&:focus-visible::after,
				&:hover::after {
					transform: scaleX(1);
				}
			}
		}
		.app-header__button {
			display: flex;
			position: absolute;
			right: 0;
			height: 42px;
		}
		.app-header__burger {
			display: none;
		}
	}
</style>
